export default function ConfirmAddBene(props){
    return (
        <div
  className="modal fade text-left show"
  id="verify_modal"
  tabIndex={-1}
  role="dialog"
  style={{ display: "block", paddingRight: 15, zIndex:999,position:"fixed",inset:0,backgroundColor:'rgba(0, 0, 0, 0.9)' }}
>
  <div
    className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    role="document"
  >
    <div className="modal-content">
      <div className="modal-header bg-danger">
        <h6 className="modal-title">{props.title}</h6>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => props.closeModal()}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <strong>Account Number :</strong>
        <span className="v_account_number float-right">{props.accountNo}</span>
        <br />
        <strong>Bank Name :</strong>
        <span className="v_bank_name float-right">{props.bankName}</span>
        <br />
      </div>
      <div className="modal-footer">
        <button className="btn btn-primary" onClick={() => props.accountVerificationConfirm()}>
          Confirm
        </button>
        <button
          className="btn btn-default"
          onClick={() => props.closeModal()}
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
    );
}